import { FunctionComponent, useEffect, useState } from 'react';
import { Modal, Skeleton } from 'antd';
import { useStore } from '@hub/helpers/use-store';
import { LoadingState, useLoading } from '@monorepo/react-hooks';
import { ConsistencyRules } from '@monorepo/types';
import AccountProfitableDays from '../account-profitable-days/account-profitable-days';

interface Props {
  accountId: string;
  open: boolean;
  close: () => void;
}

const ProfitableDaysModal: FunctionComponent<Props> = ({
  open,
  close,
  accountId,
}) => {
  const {
    dataStore: { accountStore },
  } = useStore();
  const [profitableDays, setProfitableDays] = useState<Date[]>([]);
  const { loadingState, updateLoadingState } = useLoading();

  useEffect(() => {
    if (open) {
      updateLoadingState(LoadingState.Loading);

      accountStore
        .getConsistencyRule(accountId, ConsistencyRules.ProfitableDays)
        .then((result) => {
          const { profitableDays } = result;

          if (profitableDays) {
            setProfitableDays(profitableDays);
          }
        })
        .finally(() => updateLoadingState(LoadingState.Loaded));
    }
  }, [open]);

  const isLoading = loadingState === LoadingState.Loading;

  return (
    <Modal onCancel={close} footer={null} open={open}>
      {isLoading ? (
        <Skeleton active={true} />
      ) : (
        <AccountProfitableDays profitableDays={profitableDays} />
      )}
    </Modal>
  );
};

export default ProfitableDaysModal;
